
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/serviceDetails',['Vue', 'vuex', 'vue!basicComponents/checkBox', 'vue!basicComponents/serviceCounter', 'vue!./packageItem', 'helpers', 'vue!./ageRestrictionComponent', 'vue!./dummy','vue!./userComponent', 'vue!../packageSelectionComponent/onetimeServiceBooker'], function (Vue, vuex, checkBox, serviceCounter, packageItem, helpers, ageRestrictionComponent, dummy,userComponent,onetimeServiceBooker) {
        return {
            template: template,
            props: ['service', 'users', 'package_item', 'selected'],
            components: {
                'check-box': checkBox,
                'service-counter': serviceCounter,
                'package-item': packageItem,
                'onetime-service-booker' :onetimeServiceBooker,
                'age-restriction-component': ageRestrictionComponent,
                'dummy': dummy,
                'user-component':userComponent
            },
            data: function () {
                return {
                    showMemberDropdown: false,
                    serviceForAllUsers: false,
                    showPIDetailsFor: null,
                    listOfUsersWithService:{}
                }
            },
            computed: _.extend(vuex.mapState(['selectedServices', 'activeStep', 'activeUser', 'desktopMode', 'usersWithIds', 'guestProfiles', 'activeService','ageRestrictionErrMessages', 'OTBactive', 'isAgeValid']), {
                enableScheduleBtn: function () {
                    if (this.service.SpaItemId == this.activeService)
                        return this.isValidToSchedule()
                },
                isAllGmSelected: function(){
                    return this.selectedServices[this.activeService] && this.selectedServices[this.activeService].length == _.keys(this.users).length;
                },
                isAgeRestrictActive: function(){
                    return !!this.service.MinAge || !!this.service.MaxAge;
                }
            }),
            methods: _.extend(vuex.mapMutations(['addService', 'setActiveStep', 'addGlobalMessage', 'SetmobileViewMessages']), {
                handleKeyDown: function (e) {
                    this.a11yKeyDown(e, {
                        enter: function () {
                            e.target.click();
                        },
                        space: function () {
                            e.target.click();
                        }
                    });
                },
                toggleShowMemberDropdown: function (bool) {
                    this.showMemberDropdown = bool
                },
                ageChecking: function (customerId) {
                    if (this.service.SpaItemId == this.activeService) {
                        return this.verifyAge(this.service, customerId)
                    }
                },
                selectedPerUser: function (userId) {
                    var vm = this;
                   

                    if (this.singleBookingMode) { //in order to reselect same service again.
                        return _.values(this.users[userId]).some(function (item) {
                            if(item.service && item.service.length){
                                return item.service && _.filter(item.service, function(el){return el.SpaItemId == vm.service.SpaItemId && !item.SpaFolioItemId }).length
                            }else{
                                return item.service && item.service.SpaItemId == vm.service.SpaItemId && !item.SpaFolioItemId
                            }
                        })
                    } else {
                        return _.keys(this.users[userId]).some(function (item) {
                            return item.split('-')[0] == vm.service.SpaItemId;
                        })
                        //temp-r
                    }
                },
                addServiceToAll: function (e) {
                    var vm = this
                    var checked = !!!vm.isAllGmSelected
                    var users = Object.keys(vm.users)
                    _.each(users, function (userId) {
                        var userIsChecked = false;
                        userIsChecked = vm.selectedPerUser(userId) && checked,
                            thisUserHasService = vm.noSelectedServiceForUser(userId)
                        if (!userIsChecked && !thisUserHasService) return
                        vm.$emit('handle-Multiple-Click', userId, checked)
                        if (checked) {
                            thisUserHasService ? vm.ageChecking(userId) : ''
                        } else {
                            //in case datepicker was added when checked
                            delete vm.guestProfiles[userId].requireDatePicker
                            //remove its entry from schedulebtnvalidations so that it doesnt play any role in disabling/enabling of schedule button
                            vm.$store.commit('setScheduleBtnValidity', {
                                id: userId,
                                action: "remove"
                            })
                        }
                    })
                },
                noSelectedServiceForUser: function(userId) {
                    //logic added as apart fo axosoft ticket #10913. Example: If brian has selected a service A in category one, then disable the user selection for service B in the same category. Also, render message to notify the user
                    var vm = this,
                    allow = true,
                    selectedServiceForUser = {}

                    if (vm.service.SpaItemId != vm.activeService) return allow

                    if (!vm.users[userId] || _.isEmpty(vm.users[userId]))  return allow
                    if(vm.package_item) return allow

                    _.each(vm.users[userId],function(v,k){
                          allow =  ((k.split('-')[0] == vm.service.SpaItemId) || !!v.SpaFolioItemId )
                    })
                    if (!allow) {
                        selectedServiceForUser = _.find(_.values(vm.users[userId]),function(v){return !v.SpaFolioItemId})
                    }
                    vm.$store.commit('setlistOfUsersWithService',{id:userId,service:selectedServiceForUser})
                    return allow

                },
                handleMultipleClick: function (userId, checked) {
                    this.selected = true;
                    if (this.singleBookingMode && this.package_item) this.$store.commit('removeServicesInSingleBookMode')
                    //logic that handles age varification
                    if (checked) this.ageChecking(userId)
                    else {
                        //in case datepicker was added when checked
                        delete this.guestProfiles[userId].requireDatePicker
                        //remove its entry from schedulebtnvalidations so that it doesnt play any role in disabling/enabling of schedule button
                        this.$store.commit('setScheduleBtnValidity', {
                            id: userId,
                            action: "remove"
                        })
                    }
                    this.$emit('handle-Multiple-Click', userId, checked)
                },

                hide: function () {
                    if (this.showMemberDropdown == true) this.showMemberDropdown = false;
                },
                MarkDownDesc: function (text) {

                    return helpers.nl2br(text)
                },
                handleAdd: function () {
                    if (Object.keys(this.users).length == 0) {
                        if (this.desktopMode) {
                            this.addGlobalMessage({
                                type: 'warn',
                                message: app.localization.spaBooking.packageBooking.errors.noGuestSelected
                            });
                            $('.messages-container')[0].scrollIntoView({
                                block: 'center',
                                behavior: "smooth"
                            });
                        } else {
                            this.SetmobileViewMessages({
                                key: 'fail',
                                message: app.localization.spaBooking.packageBooking.errors.noGuestSelected
                            })
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            })
                        }
                        return;
                    }
                    if (Object.keys(this.users).length > 1) {
                        this.showMemberDropdown = true;
                    } else {
                        if (this.singleBookingMode) this.singleAddSingleBookMode()
                        //else this.$parent.handleSingleAdd(!!!this.selected)
                        else this.$emit('handle-Single-Add', !!!this.selected)
                    }
                },
                selectedThis: function (userId) {
                    // return this.$parent.selected(userId);
                    return this.$emit('selected', userId)
                },
                serviceCount: function (userId) {
                    // return this.$parent.serviceCount(userId);
                    return this.$emit('service-Count', userId)
                },
                singleAddSingleBookMode: function () { //replace it soon
                    // if (!!!this.selected == false) this.$parent.handleSingleAdd(!!this.selected)
                    // else this.$parent.handleSingleAdd(!!!this.selected)
                    if (!!!this.selected == false)    this.$emit('handle-Single-Add',!!this.selected)
                    else    this.$emit('handle-Single-Add',!!!this.selected)
                    if(!this.OTBactive){
                        this.setActiveStep(this.activeStep + 1)
                    }

                },
                handleLoadedImage: function (e) {
                    e.target.style.display = "block"
                    e.target.parentElement.classList.remove('nongrid-img-dec')
                }
            }),
            events: {
                handleOutsideClick: function (event) {
                    this.showMemberDropdown = false
                }
            },
            beforeMount: function () {
                if(this.ageChecking(Object.keys(this.users)[0])) this.$store.commit('setIsAgeValid', this.ageChecking(Object.keys(this.users)[0]).isValid);
                _.each(_.values(this.guestProfiles), function (val) {
                    delete val.requireDatePicker
                    if (!val.DateOfBirth) delete val.addedByDatePicker
                })
            }
        }
    });
})('<div class="service-details"> <div class="img-desc nongrid-img-dec"> <img style="display:none" :src="service.ItemImage ||service.PackageImage" @load="handleLoadedImage"> <div class="details"> <div v-html="MarkDownDesc(service.ItemDesc || service.PackageDesc)"></div> <div class="service-details-clientInstruction" v-html="MarkDownDesc(service.ClientInstructions)"> </div> </div> </div> <div class="packages " v-if="package_item"> <package-item v-for="(pkg,index) in package_item.PackageItems.PackageItem" :key="index" :index="index" :pkg="pkg" :showDetails.sync="showPIDetailsFor" /> </div> <onetime-service-booker v-if="selectedServices[service.SpaItemId] && OTBactive && (this.$store.state.status != \'E\') && (!isAgeRestrictActive || isAgeValid !== false)" :service="service"></onetime-service-booker> <div class="controls" v-click-outside="hide"> <button v-if="!singleBookingMode" class="btn" :class=" !selected ? \'btn-warning\' : null" v-on:click="handleAdd()"> {{ ( !selected || Object.keys(users).length > 1 ) ? localStrings.stepper.body.pick.service.details.selectButtonText : localStrings.stepper.body.pick.service.details.removeButtonText }} </button> <div class="service-for" :class="Object.keys(users).length <= 1? \'service-for-border\':null"> <div v-if="Object.keys(users).length > 1"> <div class="all-none-checkbox" v-show="singleBookingMode && !package_item" @click="addServiceToAll" role="button" aria-pressed="false" aria-label="Add service to all" > <div class="custom-check-box" tabindex="0" @keydown="handleKeyDown"><i v-show="isAllGmSelected" class="fas fa-check"></i></div> <span class="">{{localization.spaBooking.packageBooking.allNoneCheckBoxLabel}} <i class="fas fa-user"></i> </span> </div> <div> <div v-for="userId in Object.keys(users)" :key="userId" :id="userId+\'-\'+service.SpaItemId" > <!-- <check-box :userId="userId" :selected="selectedPerUser(userId)" @handle-Multiple-Click="handleMultipleClick" @toggle-ShowMember-Dropdown="toggleShowMemberDropdown"> </check-box> <span class="user_name">{{usersWithIds[userId]}}</span> <dummy v-bind:customerID="userId" v-bind:service="service" :selected="selectedPerUser(userId)"></dummy> --> <user-component v-bind:userId="userId" v-bind:service="service" v-bind:selected="selectedPerUser(userId)" v-bind:isAllowedToSelect="noSelectedServiceForUser(userId)" v-on:selectedPerUser="selectedPerUser" v-on:handleMultipleClick="handleMultipleClick" v-on:toggleShowMemberDropdown="toggleShowMemberDropdown" ></user-component> </div> </div> </div> <div v-else> <dummy v-bind:customerID="Object.keys(users)[0]" v-bind:service="service" :isAgeValid="isAgeValid" :isAgeRestrictActive="isAgeRestrictActive" ></dummy> </div> <div v-show="!OTBactive"> <button v-if=" Object.keys(users).length > 1" class="btn service-for-button" :class="{ disabled: !selectedServices[service.SpaItemId]||!enableScheduleBtn, \'btn-warning\': selected }" v-on:click="!!selectedServices[service.SpaItemId] && setActiveStep(activeStep+1)">{{localStrings.stepper.body.pick.service.details.bookTimeButtonText}} </button> <button v-else :class="[\'btn btn-warning service-for-button\',{disabled: Object.keys(users).length==0||!enableScheduleBtn}]" v-on:click="handleAdd()"> {{ localStrings.stepper.body.pick.service.details.bookTimeButtonText}} </button> </div> </div> </div> </div>');
